import { useRef, useState } from "react";

export function useRecorder() {
  const [recording, setRecording] = useState(false);
  const rec = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mr = new MediaRecorder(stream);
    chunks.current = [];
    mr.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    rec.current = mr;
    mr.start();
    setRecording(true);
  };

  const stop = () =>
    new Promise((resolve) => {
      const mr = rec.current;
      if (!mr || mr.state === "inactive") return resolve(null);
      mr.onstop = () => {
        mr.stream.getTracks().forEach((t) => t.stop());
        resolve(new Blob(chunks.current, { type: mr.mimeType || "audio/webm" }));
      };
      mr.stop();
      setRecording(false);
    });

  return { recording, start, stop };
}
